import React from "react";
import yup from "yup";
import { compose, withProps } from "recompose";
import { Redirect } from "react-router-dom";
import { parse } from "query-string";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { fetchApi } from "core/api/hoc";
import { insider } from "routes/paths";
import { createErrorsSelector } from "core/helpers";
import * as api from "modules/user/auth/api";
import * as selectors from "modules/user/auth/selectors";
import * as referralApi from "modules/referral/api";
import * as referralSelectors from "modules/referral/selectors";
import { unauthenticated } from "modules/user/auth/hoc";
import View from "./View";

export default compose(
  unauthenticated,
  fetchApi(referralApi.validateInsiderInvitation, ({ location }) => {
    const { id, token } = parse(location.search);
    return {
      key: "validate",
      selector: referralSelectors.validateInsiderInvitationApi,
      sync: true,
      payload: {
        id,
        token
      }
    };
  }),
  connect(
    createStructuredSelector({
      insiderSignUpApi: selectors.insiderSignUpApi,
      errors: createErrorsSelector(selectors.insiderSignUpApi)
    }),
    dispatch => ({
      onSubmit: ({ ...values }) => {
        const payload = {
          ...values
        };
        dispatch(api.insiderSignUp.request({ body: payload }));
      }
    })
  ),
  withProps(props => ({
    validationSchema: yup.object().shape({
      first_name: yup.string().required("First name is required"),
      last_name: yup.string().required("Last name is required"),
      email: yup
        .string()
        .required("Email is required")
        .email("Is not valid email"),
      password: yup
        .string()
        .required("Password is required")
        .min(8, "Password should be at least 8 characters length"),
      password_confirmation: yup
        .string()
        .oneOf([yup.ref("password"), null], "Passwords don't match"),
      phone: yup.string().required("phone number is required")
    }),
    isValidToken: !props.validate.error
  }))
)(
  ({ ...props }) =>
    props.isValidToken ? (
      <View {...props} />
    ) : (
      <Redirect to={insider.invalidToken} />
    )
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/SignUp/Provider.js